import { h } from 'preact';
import './index.less';
import { getPrimaryLoaderStyle } from '../../lib/Utils';

const PrimaryLoader = ({ containerStyle = {}, size = '3px', loaderStyle = {} }) => (
  <div className="primary-loader-container" style={containerStyle}>
    <div className="primary-loader" style={{ ...getPrimaryLoaderStyle(size), ...loaderStyle }} />
  </div>
);

export default PrimaryLoader;
